/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */

import { PureComponent } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { icons } from '../../../assets';
import { Button } from '../../../components/common';
import { ButtonImageStyled } from '../../../components/common/Button/styled/ButtonStyled';
import ArrowTooltip from '../../../components/common/Tooltip/Tooltip';
import { IRootReducer } from '../../../reducers/rootReducer';
import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import { ICommonTranslation } from '../../internationalization/types';
import { makeSelectIsDensityListViewEnabled } from '../../role/selectors/guardSelector';
import { makeSelectIsDensity } from '../../storage/storageSelectors';
import { setDensityListView } from '../densityActions';
import { ISetDensityListViewPayload } from '../densityTypes';

type IDensityButtonComponent = IDensityButtonProps & IConnectProps & IDispatchProps;

export class DensityButton extends PureComponent<IDensityButtonComponent> {
    onClick = () => {
        this.props.setDensityListView({
            page: this.props.page,
            value: !this.props.isDensity,
        });
    };

    render() {
        const tooltip = this.props.translation.lists.densityListView.buttonToggle.tooltip;
        return (
            this.props.isEnabled &&
            <Button
                className="density-button"
                dataName="refresh"
                height="32px"
                kind="circle"
                onClick={this.onClick}
            >
                <ArrowTooltip
                    dataName="tooltipDensity"
                    message={this.props.isDensity ? tooltip.toDefault.text : tooltip.toCompact.text}
                    placement="bottom-end"
                    title={this.props.isDensity ? tooltip.toDefault.title : tooltip.toCompact.title}
                >
                    <ButtonImageStyled alt="density-icon"
                                       src={this.props.isDensity ? icons.densityOff : icons.densityOn}>
                    </ButtonImageStyled>
                </ArrowTooltip>
            </Button>
        );
    }
}

export interface IDensityButtonProps {
    page: string;
}

export interface IConnectProps {
    isDensity: boolean;
    isEnabled: boolean;
    translation: ICommonTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectProps>({
    isDensity: makeSelectIsDensity(),
    isEnabled: makeSelectIsDensityListViewEnabled(),
    translation: makeSelectTranslationCommon(),
});

export interface IDispatchProps {
    setDensityListView: (payload: ISetDensityListViewPayload) => void;
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    setDensityListView: (payload) => dispatch(setDensityListView(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DensityButton);
